import { createFileRoute } from "@tanstack/react-router";
import ProgramsDataGrid from "@components/preferences/programs/ProgramsDataGrid.tsx";
import AppCard from "@components/AppCard.tsx";
import { requireRole } from "@/auth/requireRole.ts";
import { ROLE_ADMIN } from "@/constants";

export const Route = createFileRoute("/_dashboard/preferences/programs")({
  beforeLoad: (args) => {
    requireRole([ROLE_ADMIN])(args);
  },
  component: ProgramsPreferencesPage,
});

function ProgramsPreferencesPage() {
  return (
    <AppCard>
      <ProgramsDataGrid />
    </AppCard>
  );
}
